import { combineReducers } from 'redux'

import devices from './devices/reducers'

export default combineReducers({
  devices,
})
